import { render, staticRenderFns } from "./LaporanTukarPromoMerchant.vue?vue&type=template&id=47d986f1"
import script from "./LaporanTukarPromoMerchant.vue?vue&type=script&lang=js"
export * from "./LaporanTukarPromoMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports